export const BaseURL = `https://apistaging.the-aichallenge.com`;
// export const BaseURL = `https://api.the-aichallenge.com`;

export const loginURL = `${BaseURL}/dashboard/login`;
export const logoutURL = `${BaseURL}/dashboard/logout`;
export const userInfo = `${BaseURL}/dashboard/loggedInInfo`;
export const categoriesURL = `${BaseURL}/dashboard/categories`;
export const ageGroupsURL = `${BaseURL}/dashboard/ageGroups`;
export const teamURL = `${BaseURL}/dashboard/team`;
export const teamsURL = `${BaseURL}/dashboard/teams`;
export const missionsURL = `${BaseURL}/dashboard/missions`;
export const judgesURL = `${BaseURL}/dashboard/judges`;
export const missionJudgingURL = `${BaseURL}/dashboard/missionJudgings`;
export const reportsURL = `${BaseURL}/dashboard/scoringReports`;
export const generateReportsURL = `${BaseURL}/dashboard/finalReports/ageGroup`;
export const activateURL = `${BaseURL}/activate`;
export const rankingURL = `${BaseURL}/dashboard/ranking`;
export const submissionsURL = `${BaseURL}/dashboard/mcq-submissions`;
export const mcqTeamSubmissionURL = `${BaseURL}/dashboard/team-submissions`;
